import { render, staticRenderFns } from "./JsonTreeEditor.vue?vue&type=template&id=b3321056&scoped=true"
import script from "./JsonTreeEditor.vue?vue&type=script&lang=js"
export * from "./JsonTreeEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3321056",
  null
  
)

export default component.exports